/* global axios */
import ApiClient from './ApiClient';

class AttachmentsAPI extends ApiClient {
  constructor() {
    super('attachments', { accountScoped: true });
  }

  // General media gallery (account level)
  // filters: { contactId, fileType, since, until, page }
  get(filters = {}) {
    const { contactId, fileType, since, until, page = 1 } = filters;
    const params = { page };
    if (contactId) params.contact_id = contactId;
    if (fileType) params.file_type = fileType;
    if (since) params.since = since;
    if (until) params.until = until;
    return axios.get(this.url, { params });
  }

  // Per-contact attachments (reuses upstream contacts endpoint)
  getByContact(contactId, page = 1) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/attachments`, {
      params: { page },
    });
  }
}

export default new AttachmentsAPI();
